/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: DeletionConfirmPopver.tsx
 * Project: mle-client
 * Committed last: 2021/11/9 @ 2220
 * ---
 */

import { Button, Intent }  from '@blueprintjs/core';
import React, { useState } from 'react';
import { Popover2 }        from '@blueprintjs/popover2';

interface DeletionConfirmPopverProps {
  onConfirm: (...args: any) => any;
  children: any;
}

export const DeletionConfirmPopver = (props: DeletionConfirmPopverProps) => {
  const [ isDeleting, setIsDeleting ] = useState(false);

  return (
    <Popover2 content={ <div className="p-3">
      Sei sicuro di voler procedere?
      <div/>
      <Button
        className="mt-2"
        intent={ Intent.DANGER }
        loading={ isDeleting }
        small
        icon="trash"
        onClick={ async () => {
          setIsDeleting(true);
          await props.onConfirm();
          setIsDeleting(false);
        } }
      >Sì, elimina</Button>
    </div> }>
      { props.children }
    </Popover2>
  );
};
